import { render, staticRenderFns } from "./visaflowIndex.vue?vue&type=template&id=30134448&"
import script from "./visaflowIndex.vue?vue&type=script&lang=js&"
export * from "./visaflowIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports